import $ from '@vaersaagod/tools/Dom';

require('intersection-observer');

export default el => {
    const dom = $(el);
    const footer = $('#bottom');
    let isSticky = false;

    const inviewSetup = () => {
        if ($('html').hasClass('is-live-preview')) {
            return;
        }

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const { isIntersecting, boundingClientRect } = entry;

                if (isIntersecting && isSticky) {
                    isSticky = false;
                    dom.removeClass('is-sticky');
                } else if (!isSticky && !isIntersecting && boundingClientRect.y <= 50) {
                    isSticky = true;
                    dom.addClass('is-sticky');
                }
            });
        }, {
            root: null,
            rootMargin: '-50px 0px 0px 0px',
            threshold: 1
        });
        observer.observe(el);

        const footerObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const { isIntersecting } = entry;

                if (isIntersecting && !dom.hasClass('js-fade')) {
                    dom.addClass('js-fade');
                } else if (!isIntersecting && dom.hasClass('js-fade')) {
                    dom.removeClass('js-fade');
                }
            });
        }, {
            root: null,
            rootMargin: '0% 0% -50% 0%',
            threshold: 0
        });

        footerObserver.observe(footer.get(0));
    };

    const adjustPosition = () => {
        let $target = $('[data-sticky-heading-target]');
        let $contentWrap = $('#main-content');
        let $headingContent = dom.find('[data-heading-content]');
        
        if ($target.length > 0 && $headingContent.length > 0) {
            //console.log($target.offset().top, $contentWrap.offset().top, $target.height(), $headingContent.width(), $headingContent.get(0).getBoundingClientRect());
            dom.css({ top: (($target.offset().top - $contentWrap.offset().top) + ($target.height()/2) - ($headingContent.width()/2)) + 'px' })
        }
    };
    
    const init = () => {
        adjustPosition();
        setTimeout(adjustPosition, 500);
        setTimeout(adjustPosition, 3000);
        inviewSetup();
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/StickyHeading.js